export const DEFAULT_WARNING_MESSAGE = (
  <>
    <b>Please note:</b> prepaid cards are not accepted as a payment method on
    GCX. Please select an alternative payment method.
  </>
);

export const FORM_TEMPLATE = [
  {
    id: "cardNumber",
    label: "Card Number",
    children: <figure className="payment-networks" />
  },
  {
    id: "expiration",
    label: "Expiration Date",
    shortInput: true
  },
  {
    id: "securityCode",
    label: "Security Code",
    shortInput: true
  },
  {
    id: "address-element",
    label: "Address"
  }
];
